import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { IEnvironment } from './iEnvironment';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: IEnvironment = {
    production: false,
    envName: 'dev',
    bffApiUrl: 'https://planner-bff.dev.rax-ip.net',
    bffSignalApiUrl: 'https://planner-bff.dev.rax-ip.net',
    bffSignalNegotiateVersion: 0,
    msalConfig: {
        auth: {
            clientId: '827e2117-56c4-4638-829c-3aac1fc3efc7',
            authority: 'https://raxlcl.b2clogin.com/raxlcl.onmicrosoft.com/B2C_1_SignUpIn',
            knownAuthorities: ['raxlcl.b2clogin.com'],
            redirectUri: '/auth',
            postLogoutRedirectUri: '/logout',
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback(_loglevel: LogLevel, message: string) {
                    console.log(message);
                },
                logLevel: LogLevel.Warning,
                piiLoggingEnabled: false,
            },
        },
    },
    msalProtectedResources: {
        RaxBFFApi: {
            endpoint: 'https://planner-bff.dev.rax-ip.net/api/*',
            scopes: ['https://raxlcl.onmicrosoft.com/0c287727-d8ea-4a87-ae1f-49e87e9e3fb1/accessapi'],
        },
    },
    msalB2BPolicies: {
        names: {
            signUpSignIn: 'B2C_1_SignUpIn',
            editProfile: 'B2C_1_ProfileEdit',
            passwordReset: 'B2C_1_PasswordReset',
        },
        authorities: {
            signUpSignIn: {
                authority: 'https://raxlcl.b2clogin.com/raxlcl.onmicrosoft.com/B2C_1_SignUpIn',
            },
            editProfile: {
                authority: 'https://raxlcl.b2clogin.com/raxlcl.onmicrosoft.com/B2C_1_ProfileEdit',
            },
            passwordReset: {
                authority: 'https://raxlcl.b2clogin.com/raxlcl.onmicrosoft.com/B2C_1_PasswordReset',
            },
        },
        authorityDomain: 'raxlcl.b2clogin.com',
    },
};
